export default __webpack_public_path__ + "images/DD.f16fb74.png";